export const messages = {
  en: {
    menu: {
      about: "About",
      gallery: "Gallery",
      facilities: "Facilities",
      reviews: "Reviews",
      contact: "Contact",
    },
    hero: {
      title: "Sea Gem",
      subtitle: "Privlaka",
      country: "Croatia",
    },
    about: {
      title: "About the Property",
      text: `Sea Gem is a modern, luxurious villa located directly on a picturesque beach in the quiet Privlaka area, near Zadar. Its unique location provides direct access to the crystal-clear sea and panoramic views from the spacious terrace. 
      The villa offers a beautifully landscaped garden with a heated private pool. On the terrace, you will find sun loungers and a space for evening gatherings with a glass of wine – all with a view of the sunset over the Adriatic. 
      Inside, Sea Gem impresses with modern design, spaciousness, and comfort. Air-conditioned bedrooms ensure a restful sleep, and the fully equipped kitchen allows for meal preparation. The dining area and the spacious living room with large windows create an open, bright space that encourages spending time together.
      `
    },
    gallery: {
      title: "Gallery",
      more: "More Photos",
      back: "Back",
      gallery: "Gallery",
      living_room: "Living Room",
      pool_and_bbq: "Pool and BBQ",
      first_bedroom: "First Bedroom",
      second_bedroom: "Second Bedroom",
      third_bedroom: "Third Bedroom",
      first_bathroom: "First Bathroom",
      second_bathroom: "Second Bathroom",
      third_bathroom: "Third Bathroom",
      surroundings: "Surroundings"
    },
    facilities: {
      title: "Facilities",
      pool: "Swimming Pool",
      wifi: "Wi-Fi",
      ac: "Air Conditioning",
      parking: "Parking",
      sea_view: "Sea View",
      private_beach: "Beach",
      bbq: "BBQ Grill",
      dishwasher: "Dishwasher",
      washing_machine: "Washing Machine",
      smart_tv: "Smart TV",
      garden: "Garden",
      balcony: "Balcony/Terrace"
    },
    reviews: {
      title: "Guest Reviews",
      r1: "Wonderful place! The views take your breath away.",
      r2: "Great location and very clean house.",
      r3: "Our kids loved the pool. We will definitely come back!",
      r4: "Quiet and peaceful, yet close to Zadar – perfect combination.",
      r5: "The villa is equipped to the highest standard. We lacked nothing.",
      r6: "Sitting on the terrace in the evening with a sea view – priceless.",
      r7: "The owners are very helpful and kind. Highly recommend!"
    },
    contact: {
      title: "Contact",
      address: "Address:",
      phone: "Phone:",
      email: "Email:",
      form: { name: "Name", message: "Message", send: "Send", sending: "Sending..." },
      successTitle: "Thank you for contacting us!",
      successMsg: "We will reply soon.",
      back: "Back",
    },
    error: {
      required: "All fields must be filled in",
      invalidEmail: "Invalid email",
      error: "Something went wrong – please try again later"
    }
  },

  pl: {
    menu: {
      about: "O nas",
      gallery: "Galeria",
      facilities: "Udogodnienia",
      reviews: "Opinie",
      contact: "Kontakt",
    },
    hero: { title: "Sea Gem", subtitle: "Privlaka", country: "Chorwacja" },
    about: {
      title: "Opis posiadłości",
      text: "Sea Gem to nowoczesna, luksusowa willa położona bezpośrednio przy malowniczej plaży w spokojnej okolicy Privlaka, nieopodal Zadaru. Jej wyjątkowe położenie zapewnia bezpośredni dostęp do krystalicznie czystego morza oraz panoramiczne widoki, które można podziwiać z przestronnego tarasu. Willa oferuje pięknie zagospodarowany ogród z podgrzewanym prywatnym basenem. Na tarasie znajdziesz leżaki oraz miejsce na wieczorne spotkania przy lampce wina - wszystko to z widokiem na zachód słońca nad Adriatykiem. Wewnątrz Sea Gem zachwyca nowoczesnym designem, przestronnością oraz komfortem. Klimatyzowane sypialnie zapewniają spokojny sen, a w pełni wyposażona kuchnia umożliwia przygotowywanie posiłków. Jadalnia i przestronny salon z dużymi przeszkleniami tworzą otwartą, jasną przestrzeń sprzyjającą wspólnemu spędzaniu czasu."
    },
    gallery: {
      title: "Galeria",
      more: "Więcej zdjęć",
      back: "Wróć",
      gallery: "Galeria",
      living_room: "Salon",
      pool_and_bbq: "Basen i grill",
      first_bedroom: "Pierwsza sypialnia",
      second_bedroom: "Druga sypialnia",
      third_bedroom: "Trzecia sypialnia",
      first_bathroom: "Pierwsza łazienka",
      second_bathroom: "Druga łazienka",
      third_bathroom: "Trzecia łazienka",
      surroundings: "Otoczenie"
    },
    facilities: {
      title: "Udogodnienia",
      pool: "Basen",
      wifi: "Wi-Fi",
      ac: "Klimatyzacja",
      parking: "Parking",
      sea_view: "Widok na morze",
      private_beach: "Plaża",
      bbq: "Grill",
      dishwasher: "Zmywarka",
      washing_machine: "Pralka",
      smart_tv: "Smart TV",
      garden: "Ogród",
      balcony: "Balkon/Taras"
    },
    reviews: {
      title: "Opinie gości",
      r1: "Cudowne miejsce! Widoki zapierają dech w piersiach.",
      r2: "Wspaniała lokalizacja i bardzo czysty dom.",
      r3: "Nasze dzieci uwielbiały basen. Na pewno wrócimy!",
      r4: "Cisza, spokój, a zarazem bliskość do Zadaru – idealne połączenie.",
      r5: "Wyposażenie willi na najwyższym poziomie. Niczego nam nie brakowało.",
      r6: "Siedzenie wieczorem na tarasie z widokiem na morze – bezcenne.",
      r7: "Właściciele bardzo pomocni i uprzejmi. Polecam każdemu!"
    },
    contact: {
      title: "Kontakt",
      address: "Adres",
      phone: "Telefon",
      email: "Email",
      form: { name: "Imię", message: "Wiadomość", send: "Wyślij", sending: "Wysyłanie..." },
      successTitle: "Dziękujemy za kontakt!",
      successMsg: "Odezwiemy się wkrótce.",
      back: "Wróć",
    },
    error: {
      required: "Wszystkie pola muszą być wypełnione",
      invalidEmail: "Niepoprawny email",
      error: "Coś poszło nie tak - proszę spróbuj ponownie później"
    }
  },
  hr: {
    menu: {
      about: "O nama",
      gallery: "Galerija",
      facilities: "Sadržaji",
      reviews: "Recenzije",
      contact: "Kontakt",
    },
    hero: { title: "Sea Gem", subtitle: "Privlaka", country: "Hrvatska" },
    about: {
      title: "Opis objekta", text: `Sea Gem je moderna, luksuzna vila smještena neposredno uz slikovitu plažu u mirnom području Privlaka, nedaleko Zadra. Njena jedinstvena lokacija pruža izravan pristup kristalno čistom moru i panoramski pogled s prostrane terase. 
    Vila nudi prekrasno uređeni vrt s grijanim privatnim bazenom. Na terasi ćete pronaći ležaljke i prostor za večernja druženja uz čašu vina – sve s pogledom na zalazak sunca nad Jadranom. 
    Unutrašnjost Sea Gema oduševljava modernim dizajnom, prostranošću i udobnošću. Klima u spavaćim sobama osigurava miran san, a potpuno opremljena kuhinja omogućuje pripremu obroka. Blagovaonica i prostrani dnevni boravak s velikim prozorima stvaraju otvoreni, svijetli prostor koji potiče zajedničko druženje.`},
    gallery: {
      title: "Galerija",
      more: "Više slika",
      back: "Nazad",
      gallery: "Galerija",
      living_room: "Dnevni boravak",
      pool_and_bbq: "Bazen i roštilj",
      first_bedroom: "Prva spavaća soba",
      second_bedroom: "Druga spavaća soba",
      third_bedroom: "Treća spavaća soba",
      first_bathroom: "Prva kupaonica",
      second_bathroom: "Druga kupaonica",
      third_bathroom: "Treća kupaonica",
      surroundings: "Okolica"
    },
    facilities: {
      title: "Sadržaji",
      pool: "Bazen",
      wifi: "Wi-Fi",
      ac: "Klima",
      parking: "Parking",
      sea_view: "Pogled na more",
      private_beach: "Privatna plaža",
      bbq: "Roštilj",
      dishwasher: "Perilica posuđa",
      washing_machine: "Perilica rublja",
      smart_tv: "Smart TV",
      garden: "Vrt",
      balcony: "Balkon/Terasa"
    },
    reviews: {
      title: "Recenzije gostiju",
      r1: "Prekrasno mjesto! Pogledi oduzimaju dah.",
      r2: "Odlična lokacija i vrlo čist dom.",
      r3: "Naša djeca su obožavala bazen. Sigurno ćemo se vratiti!",
      r4: "Tiho i mirno, a opet blizu Zadra – savršena kombinacija.",
      r5: "Oprema vile na najvišoj razini. Ništa nam nije nedostajalo.",
      r6: "Sjediti navečer na terasi s pogledom na more – neprocjenjivo.",
      r7: "Vlasnici su vrlo susretljivi i ljubazni. Preporučujem svima!"
    },
    contact: {
      title: "Kontakt",
      address: "Adresa",
      phone: "Telefon",
      email: "Email",
      form: { name: "Ime", message: "Poruka", send: "Pošalji", sending: "Slanje..." },
      successTitle: "Hvala na kontaktu!",
      successMsg: "Odgovorit ćemo vam uskoro.",
      back: "Nazad",
    },
    error: {
      required: "Sva polja moraju biti popunjena",
      invalidEmail: "Nevažeći email",
      error: "Nešto je pošlo po zlu – molimo pokušajte ponovo kasnije"
    }
  },

  de: {
    menu: {
      about: "Über uns",
      gallery: "Galerie",
      facilities: "Ausstattung",
      reviews: "Bewertungen",
      contact: "Kontakt",
    },
    hero: {
      title: "Sea Gem",
      subtitle: "Privlaka",
      country: "Kroatien",
    },
    about: {
      title: "Über die Unterkunft",
      text: `Sea Gem ist eine moderne, luxuriöse Villa, direkt an einem malerischen Strand in der ruhigen Gegend von Privlaka, nahe Zadar, gelegen. Ihre einzigartige Lage bietet direkten Zugang zum kristallklaren Meer und Panoramablick von der großzügigen Terrasse. 
  Die Villa verfügt über einen liebevoll gestalteten Garten mit beheiztem Privatpool. Auf der Terrasse finden Sie Liegestühle und einen Bereich für gemütliche Abende mit einem Glas Wein – alles mit Blick auf den Sonnenuntergang über der Adria. 
  Im Inneren beeindruckt Sea Gem durch modernes Design, Großzügigkeit und Komfort. Klimatisierte Schlafzimmer sorgen für erholsamen Schlaf, und die voll ausgestattete Küche ermöglicht die Zubereitung von Mahlzeiten. Der Essbereich und das großzügige Wohnzimmer mit großen Fenstern schaffen einen offenen, hellen Raum, der zum gemeinsamen Verweilen einlädt.`
    },
    gallery: {
      title: "Galerie",
      more: "Weitere Fotos",
      back: "Zurück",
      gallery: "Galerie",
      living_room: "Wohnzimmer",
      pool_and_bbq: "Pool & Grill",
      first_bedroom: "Erstes Schlafzimmer",
      second_bedroom: "Zweites Schlafzimmer",
      third_bedroom: "Drittes Schlafzimmer",
      first_bathroom: "Erstes Badezimmer",
      second_bathroom: "Zweites Badezimmer",
      third_bathroom: "Drittes Badezimmer",
      surroundings: "Umgebung"
    },
    facilities: {
      title: "Ausstattung",
      pool: "Schwimmbad",
      wifi: "WLAN",
      ac: "Klimaanlage",
      parking: "Parkplatz",
      sea_view: "Meerblick",
      private_beach: "Privatstrand",
      bbq: "Grill",
      dishwasher: "Geschirrspüler",
      washing_machine: "Waschmaschine",
      smart_tv: "Smart-TV",
      garden: "Garten",
      balcony: "Balkon/Terrasse"
    },
    reviews: {
      title: "Gästebewertungen",
      r1: "Wunderbarer Ort! Die Aussicht raubt einem den Atem.",
      r2: "Tolle Lage und sehr sauberes Haus.",
      r3: "Unsere Kinder liebten den Pool. Wir kommen definitiv wieder!",
      r4: "Ruhig und friedlich, aber nah an Zadar – perfekte Kombination.",
      r5: "Die Villa ist nach höchstem Standard ausgestattet. Es hat uns an nichts gefehlt.",
      r6: "Abends auf der Terrasse mit Meerblick sitzen – unbezahlbar.",
      r7: "Die Besitzer sind sehr hilfsbereit und freundlich. Sehr zu empfehlen!"
    },
    contact: {
      title: "Kontakt",
      address: "Adresse:",
      phone: "Telefon:",
      email: "E-Mail:",
      form: { name: "Name", message: "Nachricht", send: "Senden", sending: "Senden..." },
      successTitle: "Vielen Dank für Ihre Nachricht!",
      successMsg: "Wir werden uns bald bei Ihnen melden.",
      back: "Zurück",
    },
    error: {
      required: "Alle Felder müssen ausgefüllt werden",
      invalidEmail: "Ungültige E-Mail-Adresse",
      error: "Etwas ist schiefgelaufen – bitte versuchen Sie es später erneut"
    }
  }

}